import * as Immutable from "immutable";
import { ParamValue } from "./paramValue";

export class LookupValue extends ParamValue {  

}